// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "./Layer";

export default function Directors() {
	const Icon = getOutlinedPositionIcon({ position: "Finance Director" });
	return (
		<PageLayer title={"Finance Director Pay Plans"} icon={Icon}>
			<Layer />
		</PageLayer>
	);
}
